import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#2d3438',
      dark: '#292f33',
    },
    secondary: {
      main: '#be1e2d',
      dark: '#76131c',
    },
  },
});

export default theme;